module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-209.325b38f.woff2";